import React from "react";
import { Box } from "@mui/material";
import MDTypography from "../../../../../components/MDTypography";
import PropTypes from "prop-types";
import MDButton from "../../../../../components/MDButton";

const TabPageHeader = ({ title, showButton = false, buttonLabel = "", onButtonClick }) => {
    return (
        <Box
            sx={{
                width: "100%",
                bgcolor: "#fff",
                px: 2,
                pt: 2,
                borderBottom: "1px solid #d3e3fd",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pb: 2,
                }}
            >
                <Box>
                    <MDTypography variant="overline" color="info" fontWeight="medium"
                                  sx={{
                                      fontSize: "14px"}}>
                        {title?.split(" ")[0]?.toUpperCase()}
                    </MDTypography>
                    <MDTypography fontWeight="medium"
                                  sx={{
                                      fontSize: "18px",
                                      mt: -1
                                  }}>
                        {title?.split(" ").slice(1).join(" ")}
                    </MDTypography>
                </Box>

                {showButton && (
                    <MDButton
                        variant="contained"
                        color="info"
                        onClick={onButtonClick}
                        sx={{ textTransform: "none", bgcolor: "#1a73e8" }}
                    >
                        {buttonLabel}
                    </MDButton>
                )}
            </Box>
        </Box>
    );
};

TabPageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    showButton: PropTypes.bool,
    buttonLabel: PropTypes.string,
    onButtonClick: PropTypes.func,
};

TabPageHeader.defaultProps = {
    showButton: false,
    buttonLabel: "",
};
export default TabPageHeader;
